import { Component, NgZone, Input } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { first } from 'rxjs/operators';

import { OtpVerificationPage } from 'src/app/pages/otp-verification/otp-verification.page';
import { AreaListsPage } from 'src/app/pages/area-lists/area-lists.page';
import { TermsAndConditionsPage } from 'src/app/pages/terms-and-conditions/terms-and-conditions.page';
import { environment } from 'src/environments/environment';
import { endpoints } from 'src/app/constant/endpoints';

// Services
import { ApiService } from 'src/app/provider/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/provider/config.service';
import { DataService } from 'src/app/services/data.service';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { RouterStateTrackerService } from 'src/app/services/router-state-tracker.service';

@Component({
  selector: 'signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  standalone: false,
})
export class SignUpComponent {

  @Input() subData?:any = undefined;
  // --- form model
  signUpForm = {
    areasOrRegionId: '',
    TcChecked: false,
    password: '',
    device_token: '',
    last_name: '',
    name: '',
    email: '',
    referral_code: '',
    country_iso_code: 'KW',
    phone: '',
    device_type: '',
  };

  loading:boolean = false;
  // --- UI state
  showPasswordFlag = false;
  passwordInputType: 'password' | 'text' = 'password';
  userPhoneAllowedDigit = 8;
  signUpState = '';
  areasOrRegionName = '';
  isReferralEnabled = true;

  // --- validation state
  isFirstNameValid = false;
  isLastNameValid = false;
  isEmailValid = false;
  isPhoneValid = false;
  isPasswordValid = false;
  isTcChecked = false;
  isAreasOrRegionIdValid = false;
  areaList: any =[];
  storeData: any;
  showRef: boolean;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private configService: ConfigService,
    private dataService: DataService,
    private modalCtrl: ModalController,
    private ngZone: NgZone,
    private router: Router,
    private platform: Platform,
     private device: Device,
         private routerStateTrackerService: RouterStateTrackerService,

  ) {
    const araD = this.dataService.getCachedData("areas");
    this.areaList = araD.areas;
    console.log(this.areaList, "areas")
         const config = this.dataService.getCachedData('configurations');
      console.log(config, 'config');
      this.storeData = config.organization;
        this.isReferralEnabled = this.storeData?.is_referral_enabled === 1;
        this.userPhoneAllowedDigit = this.storeData.allowed_digit_for_phone || 10;
                const referallenabled = this.storeData.is_referral_enabled;
        const loyaltyenabled = this.storeData.is_loyalty_enabled;
        if (referallenabled === 1 && loyaltyenabled === 1) {
          this.showRef = true;
        } else {
          this.showRef = false;
        }
  }

  // --- submit
  async onSubmitSignUp(): Promise<void> {
    if (!this.isValidSignupForm()) {
      this.toastMessage('please_fill_all_mandatory_fields');
      return;
    }
this.loading = true;
    // enrich with device info
    this.signUpForm.device_type = this.platform.is('android')
      ? 'android'
      : this.platform.is('ios')
      ? 'ios'
      : 'web';

    this.signUpForm.device_token = this.platform.is('capacitor')
      ? this.device.uuid // replace with this.device.uuid if using Capacitor Device
      : 'demo';

    if (!this.isReferralEnabled) {
      delete this.signUpForm.referral_code;
    }

    try {
      const response = await this.apiService
        .post(endpoints.register, this.signUpForm)
        .pipe(first())
        .toPromise();

      if (response?.success) {
        const customerData = response.data.customer;
        this.authService.setAuthToken(customerData.session_token);
        this.authService.setAuthUser(customerData);
        this.authService.setAuthVerify('false'); // until OTP is verified
this.loading = false;
        const otpModal = await this.modalCtrl.create({
          component: OtpVerificationPage,
          componentProps: {
            phone: this.signUpForm.phone,
            email: this.signUpForm.email,
            country_iso_code: this.signUpForm.country_iso_code,
            otp_sent: true,
          },
        });

        await otpModal.present();
        const { data } = await otpModal.onDidDismiss();

        if (data) {
          // OTP verified
          this.authService.setAuthVerify('true');
          // this.masterDataService.enableCaching();
          if (this.subData == undefined){
            this.loading = false;
          this.ngZone.run(() => {
            this.navigateToPage('/subscription-list');
          });
        } else {
          this.loading = false;
          this.navigateToPage('/checkout', { data });
        }
        } else {
          // OTP not verified
          this.loading = false;
          this.navigateToPage('/onboarding');
        }
      } else {
        this.loading = false;
        this.toastMessage(response?.message || 'sign_up_failed');
      }
    } catch (err: any) {
      console.error('Sign up error:', err);
      this.loading = false;
      if (err.status === 422) {
        this.toastMessage('please_fill_all_mandatory_fields');
      } else if (err.status === 400 && err.error?.message) {
        this.toastMessage(err.error.message);
      } else {
        this.toastMessage('an_unexpected_error_occurred');
      }
    }
  }

  // --- validation
  isValidSignupForm(): boolean {
    this.isFirstNameValid = (this.signUpForm.name?.trim()?.length || 0) > 2;
    this.isLastNameValid = (this.signUpForm.last_name?.trim()?.length || 0) > 2;
    this.isEmailValid = (this.signUpForm.email?.trim()?.length || 0) > 5;
    this.isPhoneValid = (this.signUpForm.phone?.trim()?.length || 0) > 5;
    this.isPasswordValid = (this.signUpForm.password?.trim()?.length || 0) > 5;
    this.isTcChecked = this.signUpForm.TcChecked === true;

    this.isAreasOrRegionIdValid =
      (Array.isArray(this.signUpForm.areasOrRegionId) &&
        this.signUpForm.areasOrRegionId.length > 0) ||
      (typeof this.signUpForm.areasOrRegionId === 'string' &&
        this.signUpForm.areasOrRegionId.length > 0) ||
      (typeof this.signUpForm.areasOrRegionId === 'number' &&
        this.signUpForm.areasOrRegionId > 0);

    return (
      this.isFirstNameValid &&
      this.isLastNameValid &&
      this.isEmailValid &&
      this.isPhoneValid &&
      this.isPasswordValid &&
      this.isTcChecked &&
      this.isAreasOrRegionIdValid
    );
  }

  // --- input handling
  onPhoneInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value.replace(/\D/g, '');
    this.signUpForm.phone = input.slice(0, this.userPhoneAllowedDigit);
  }

  togglePasswordVisibility(): void {
    this.showPasswordFlag = !this.showPasswordFlag;
    this.passwordInputType = this.showPasswordFlag ? 'text' : 'password';
  }

  // --- modals
  async openAreaModal(): Promise<void> {
    const areaModal = await this.modalCtrl.create({
      component: AreaListsPage,
      componentProps: { citylist: this.areaList }, // pass actual list
    });
    await areaModal.present();
    const { data } = await areaModal.onDidDismiss();
    if (data) {
      this.signUpForm.areasOrRegionId = data.id;
      this.areasOrRegionName = data.title;
    }
  }

  async openTermsAndConditionsModal(): Promise<void> {
    const termsModal = await this.modalCtrl.create({
      component: TermsAndConditionsPage,
      cssClass: 'basic-modal',
    });
    await termsModal.present();
    const { data } = await termsModal.onDidDismiss();
    this.signUpForm.TcChecked = data || false;
  }

  // --- utils
  // private navigateToPage(path: string, extras?: any): void {
  //   this.router.navigate([path], { queryParams: extras || {} });
  // }
  navigateToPage(page: string, data: any = { test: 'From Onb' }): void {
    const main = this.routerStateTrackerService.combinedData;
    this.routerStateTrackerService.navigateWithPreExitAnimation(page, data);
    // this.router.navigate([page], navigationExtras);
  }
  private toastMessage(key: string): void {
    // this.toast.show(key);
  }
}
